import * as React from 'react';

import { TypographyI18n } from 'components/v2';
import { generateMessageTemplateKey } from 'hooks';
import CancelButtonContainer from '../CancelButtonContainer';

type Props = {
  onClick: () => void;
  buttonRef: React.Ref<HTMLButtonElement | null>;
};

const CancelButtonInitial = (props: Props) => {
  const { buttonRef, onClick } = props;

  return (
    <CancelButtonContainer color="error" onClick={onClick} buttonRef={buttonRef}>
      <TypographyI18n variant="bW600F14" color="inherit" noWrap>
        {generateMessageTemplateKey('patientLumaBotManageAppointmentCancelAppointmentConfirmation')}
      </TypographyI18n>
    </CancelButtonContainer>
  );
};

export default CancelButtonInitial;
